import { useRef } from "react";
import { Printer, X } from "lucide-react";

function fmtMonth(m) {
  if (!m) return "—";
  const [yr, mo] = m.split("-");
  const labels = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  return `${labels[parseInt(mo, 10) - 1]} ${yr}`;
}

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-MY", { day: "2-digit", month: "short", year: "numeric" });
}

export function invoiceNumber(month) {
  if (!month) return "PERCASA-—-—";
  const [yr, mo] = month.split("-");
  return `PERCASA-${mo}-${yr}`;
}

export default function PaymentInvoice({ payment, resident, onClose }) {
  const printRef = useRef(null);

  function handlePrint() {
    window.print();
  }

  const issuedDate = fmtDate(payment.submitted_at);
  const invNo = invoiceNumber(payment.month);
  const amount = payment.amount?.toFixed(2);

  return (
    <div className="modal-overlay invoice-modal-overlay" onClick={onClose}>
      <div className="invoice-modal-wrap" onClick={e => e.stopPropagation()}>
        <div className="invoice-modal-toolbar no-print">
          <button type="button" className="btn btn-primary" onClick={handlePrint} data-testid="print-invoice-btn">
            <Printer size={14} /> Print Invoice
          </button>
          <button type="button" className="btn" onClick={onClose} data-testid="close-invoice-btn">
            <X size={14} /> Close
          </button>
        </div>

        <div className="payment-invoice" ref={printRef} data-testid="payment-invoice">
          <div className="invoice-header">
            <div className="invoice-brand">
              <img
                src={`${process.env.PUBLIC_URL}/percasa-logo.png`}
                alt="PERCASA"
                className="invoice-logo"
              />
              <div>
                <div className="invoice-brand-name">PERCASA</div>
                <div className="invoice-brand-sub">Residence Management</div>
                <div className="invoice-brand-tagline">Jiran Sepakat, Membawa Berkah</div>
              </div>
            </div>
            <div className="invoice-meta">
              <div className="invoice-title">TAX INVOICE</div>
              <div className="invoice-meta-row"><span>Invoice No.</span><strong>{invNo}</strong></div>
              <div className="invoice-meta-row"><span>Issue Date</span><span>{issuedDate}</span></div>
              {payment.billcode && (
                <div className="invoice-meta-row"><span>Bill Code</span><strong>{payment.billcode}</strong></div>
              )}
              <div className="invoice-paid-stamp">PAID</div>
            </div>
          </div>

          <div className="invoice-parties">
            <div className="invoice-party">
              <div className="invoice-party-label">Bill To</div>
              <div className="invoice-party-name">{payment.resident_name || resident?.name || "—"}</div>
              <div className="invoice-party-detail">House No.: {payment.unit || resident?.unit || "—"}</div>
              {resident?.street_number && (
                <div className="invoice-party-detail">{resident.street_number}</div>
              )}
              {resident?.email && (
                <div className="invoice-party-detail">{resident.email}</div>
              )}
            </div>
            <div className="invoice-party">
              <div className="invoice-party-label">From</div>
              <div className="invoice-party-name">PERCASA Management</div>
              <div className="invoice-party-detail">Residence Management Office</div>
              <div className="invoice-party-detail">Malaysia</div>
            </div>
          </div>

          {/* Desktop table */}
          <table className="invoice-table invoice-table-desktop">
            <thead>
              <tr>
                <th>Description</th>
                <th>Payment Month</th>
                <th>Payment Date</th>
                <th>Status</th>
                <th className="invoice-amount-col">Amount (RM)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{payment.category || "Maintenance Fee"}</td>
                <td>{fmtMonth(payment.month)}</td>
                <td>{fmtDate(payment.payment_date)}</td>
                <td>
                  <span className="invoice-status-paid">PAID</span>
                </td>
                <td className="invoice-amount-col">{amount}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4} className="invoice-total-label">Total Amount</td>
                <td className="invoice-amount-col invoice-total-value">RM {amount}</td>
              </tr>
            </tfoot>
          </table>

          {/* Mobile stacked details */}
          <div className="invoice-details-mobile">
            <div className="invoice-detail-card">
              <div className="invoice-detail-row">
                <span>Description</span>
                <strong>{payment.category || "Maintenance Fee"}</strong>
              </div>
              <div className="invoice-detail-row">
                <span>Payment Month</span>
                <strong>{fmtMonth(payment.month)}</strong>
              </div>
              <div className="invoice-detail-row">
                <span>Payment Date</span>
                <strong>{fmtDate(payment.payment_date)}</strong>
              </div>
              <div className="invoice-detail-row">
                <span>Status</span>
                <span className="invoice-status-paid">PAID</span>
              </div>
              <div className="invoice-detail-row invoice-detail-amount">
                <span>Amount</span>
                <strong className="invoice-total-value">RM {amount}</strong>
              </div>
            </div>
          </div>

          {payment.remarks && (
            <div className="invoice-remarks">
              <span className="invoice-remarks-label">Remarks:</span> {payment.remarks}
            </div>
          )}

          <div className="invoice-signature">
            <div className="invoice-signature-line" />
            <div className="invoice-signature-text">computer generated - no signature required</div>
          </div>

          <div className="invoice-footer">
            Thank you for your payment. This invoice serves as official confirmation of your approved payment record.
          </div>
        </div>
      </div>
    </div>
  );
}
